<template>
  <vs-row>
    <vs-col>
      <div v-if="!loadingVenues">
        <vs-select
          label="Venue"
          class="w-full"
          v-model="selectedVenueDetails"
          @change="$emit('venue-details-selected', selectedVenueDetails)"
          :disabled="disableComponent"
        >
          <vs-select-item
            v-for="venue in venues"
            :key="venue.venueDetailsId.id"
            :value="venue"
            :text="venue.name"
          />
        </vs-select>
      </div>
      <div v-if="loadingVenues">
        <span class="flex h-4 w-4 mt-2">
          <span
            class="
              animate-ping
              absolute
              inline-flex
              h-4
              w-4
              rounded-full
              bg-primary
              opacity-75
            "
          ></span>
          <span
            class="relative inline-flex rounded-full h-4 w-4 bg-primary"
          ></span>
        </span>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import { mapGetters } from "vuex";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";

export default {
  components: {},
  props: {
    venueDetailsId: Object,
    disableComponent: Boolean,
  },
  data() {
    return {
      loadingVenues: false,
      selectedVenueDetails: undefined,
    };
  },
  async mounted() {
    await this.getVenues();
    this.selectedVenueDetails = this.venues.find(
      (v) => v.venueDetailsId.id === this.venueDetailsId.id
    );
  },
  computed: {
    ...mapGetters({
      venues: "marcom/venues",
    }),
  },
  methods: {
    async getVenues() {
      try {
        this.loadingVenues = true;
        await this.$store.dispatch("marcom/" + VENUE_ACTIONS.GetVenues);
      } catch (err) {
        console.error(err);
        this.$vs.notify({
          color: "danger",
          title: "Error getting venues",
          text: "Getting venues failed.",
        });
      } finally {
        this.loadingVenues = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
